<template>
    <div class="m-tc-ar-ui">

    </div>
</template>

<script>
export default {
    name: 'TheMobileAR',
};
</script>

<style scoped lang="scss">
.m-tc-ar-ui {
    width: 100%;
    height: 100%;
    position: absolute;
    box-sizing: border-box;
    font-family: Montserrat, sans-serif;
    pointer-events: none;
}
</style>
